import { ProductAddCommandModel } from "../product-base-model";

export class SpecialServiceAddCommandModel extends ProductAddCommandModel {
    public seasonCode: string;
}